module.exports = __webpack_public_path__ + "static/media/Southgrove Kitchen Cooker Wall.7931b255.JPG";